import { SVGProps } from 'react';

const MessageCircleHeart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.1.092 10 10 0 1 0-4.778-4.72"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.828 13.07A3 3 0 0 1 12 8.764a3 3 0 0 1 4.172 4.307l-3.447 3.62a1 1 0 0 1-1.45 0z"
    />
  </svg>
);
export default MessageCircleHeart;
